import { useState, useEffect, useRef } from 'react';
import { getResponses } from '../../services/api';

export default function ResponsePicker({ category, onInsert, label = 'Insert from Response Library' }) {
  const [open,      setOpen]      = useState(false);
  const [responses, setResponses] = useState([]);
  const [loading,   setLoading]   = useState(false);
  const [search,    setSearch]    = useState('');
  const panelRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    getResponses(category)
      .then(setResponses)
      .catch(() => setResponses([]))
      .finally(() => setLoading(false));
  }, [open, category]);

  // Close on outside click
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const filtered = responses.filter(r =>
    !search || r.title?.toLowerCase().includes(search.toLowerCase()) ||
    r.content?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="rp-wrap" ref={panelRef}>
      <button type="button" className="rp-trigger" onClick={() => setOpen(o => !o)}>
        📚 {label}
      </button>

      {open && (
        <div className="rp-panel">
          <div className="rp-panel-header">
            <input
              autoFocus
              type="text"
              placeholder="Search responses…"
              value={search}
              onChange={e => setSearch(e.target.value)}
              className="rp-search"
            />
            <button className="rp-close" onClick={() => setOpen(false)}>✕</button>
          </div>

          <div className="rp-list">
            {loading && <div className="rp-empty">Loading…</div>}
            {!loading && filtered.length === 0 && (
              <div className="rp-empty">
                No responses found{category ? ` for "${category}"` : ''}.
              </div>
            )}
            {!loading && filtered.map(r => (
              <button
                key={r.id}
                type="button"
                className="rp-item"
                onClick={() => { onInsert(r.content); setOpen(false); setSearch(''); }}
              >
                <div className="rp-item-title">{r.title}</div>
                <div className="rp-item-preview">{r.content?.slice(0, 100)}{r.content?.length > 100 ? '…' : ''}</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
